import DefaultLayout from '##/Default';
import View from './EmployeeEvalList';
import List from './List';

const routes = [
    {
        path: '/employees/:employee_id/evals',
        exact: true,
        layout: DefaultLayout,
        component: View,
        auth: true,
        title: 'Employees'
    },
    {
        path: '/employees',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Employees'
    }
];

export default routes;
